var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRedArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E32652",
  fillRule: "evenodd",
  d: "M12 2v9a1 1 0 0 1-1 1H2a1 1 0 1 1 0-2h6.586L2.293 3.707 3 3l.707-.707L10 8.586V2a1 1 0 1 1 2 0M3 3l.707-.707a1 1 0 1 0-1.414 1.414z",
  clipRule: "evenodd"
})));
export default SvgRedArrow;